import React, { Fragment, useEffect, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { Card, CardBody, Container } from "reactstrap";
import { Breadcrumbs, P } from "../../../AbstractElements";
import { firebase_app } from "../../../Config/Config";
import i18n from "../../../i18n";
import { findUserForAuthUser, getUserProfilePath } from "./userFirebase";

const CurrentUserProfile = () => {
  const [state, setState] = useState({
    status: "loading",
    profile: null,
  });

  useEffect(() => {
    let active = true;

    const resolveProfile = async (authUser) => {
      if (!active) {
        return;
      }

      if (!authUser) {
        setState({ status: "signed-out", profile: null });
        return;
      }

      setState({ status: "loading", profile: null });

      try {
        const profile = await findUserForAuthUser(authUser);

        if (active) {
          setState({ status: "ready", profile });
        }
      } catch (error) {
        console.error("Unable to resolve current user profile", error);

        if (active) {
          setState({ status: "error", profile: null });
        }
      }
    };

    const unsubscribe = firebase_app.auth().onAuthStateChanged(resolveProfile);

    return () => {
      active = false;
      if (typeof unsubscribe === "function") {
        unsubscribe();
      }
    };
  }, []);

  if (state.status === "loading") {
    return <Container fluid><p role="status">Chargement de votre profil…</p></Container>;
  }

  if (state.status === "signed-out") {
    return <Navigate to={`${process.env.PUBLIC_URL}/auth`} replace />;
  }

  const profilePath = getUserProfilePath(state.profile);

  if (profilePath) {
    return <Navigate to={`${process.env.PUBLIC_URL}/dashboard/users/${profilePath}`} replace />;
  }

  return (
    <Fragment>
      <Breadcrumbs
        mainTitle={i18n.t("Dashboard_UserProfile_Label")}
        parent={i18n.t("Dashboard_Breadcrumb_Users")}
        title={i18n.t("Dashboard_UserProfile_Label")}
      />
      <Container fluid={true}>
        <Card>
          <CardBody className="text-center">
            <h4>Profil non lie</h4>
            <P>
              Le compte connecte n'est pas encore associe a une fiche utilisateur MaxPark.
            </P>
            {state.status === "error" && (
              <P attrPara={{ className: "text-danger" }}>
                Impossible de verifier le profil pour le moment.
              </P>
            )}
            <Link
              className="btn btn-primary"
              to={`${process.env.PUBLIC_URL}/dashboard/users`}
            >
              {i18n.t("Dashboard_Users_ViewList")}
            </Link>
          </CardBody>
        </Card>
      </Container>
    </Fragment>
  );
};

export default CurrentUserProfile;
